import Button from 'components/Button'
import Drawer from 'components/Drawer'
import Flex from 'components/Flex'
import { Tooltip } from 'antd'
// import DownLoadIcon from 'components/icons/DownLoad'
import UploadIcon from 'components/icons/Upload'
// import DownLoadCandidate from 'modules/Drives/DownloadAndUpload/DownloadCandidateDrawer/index'
import UploadResult from 'modules/Drives/DownloadAndUpload/UploadResultDrawer/index'
import { uploadFile } from 'modules/ManageProfile/actions'
import {
  IconWrapper,
  SubTextWrapper,
  TextWrapper,
  Wrapper,
} from 'modules/Drives/DownloadAndUpload/style'
import {
  downloadCandidate,
  downloadCandidateList,
  getRoleMetrics,
  uploadResultAPI,
} from 'modules/Drives/actions'
import React, { Fragment, useEffect, useState, useCallback } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import UploadShortlistedDrawer from './UploadShortlistedDrawer/index.js'
import UploadOfferDrawer from './UploadOfferDrawer/index.js'
import ResolveConflict from '../Components/ResolveConflict.js'
import ArrowForward from '../../../components/icons/ArrowForward.js'
import { Minus } from './style.js'
import { ConflictName, ShortList, TextEllipse } from '../ViewDriveRole/Style/style.js'
import UploadAssessmentDrawer from './UploadAssessmentDrawer/index.js'
import ConfirmDrawer from './UploadResultDrawer/ConfirmDrawer/index.js'
import { toCamelCase } from '../utils.js'

const DownlaodUpload = ({
  driveId,
  noNeedRole,
  roleId,
  getCandidateList,
  getGDList,
  fileUpload,
  stage,
  checkType,
  assessment,
  rolesMetrics,
  setSearchParams,
  searchParams,
  downloadTemplate,
  uploadShorlistResult,
  nextRoundFunction,
  rounds,
  nextRoundData,
  selectedRound,
  setSelectedRound,
  allRounds,
  updateResolveConflictCandidates,
  getConflictCandidates,
  roundId,
  setErrorMessage,
  setIsAllSelected,
  setSelectedIds,
  setWholeSelect,
  triggerLabel,
}) => {
  const dispatch = useDispatch()

  const driveRoleList = useSelector(state => state?.drives?.driveRolesMetrics)
  const roundList = useSelector(state => state?.drives?.roleMetrics)
  const [uploadResult, setUploadResult] = useState(false)
  const [uploadShortlisted, setUploadShortlisted] = useState(false)
  const [isDrawer, setIsDrawer] = useState(false);
  const [isOfferDrawer, setIsOfferDrawer] = useState(false);
  const [offerType, setOfferType] = useState(null)
  const [selectedRoleId, setSelectedRoleId] = useState(null)
  const [isModalOpen, setIsModalOpen] = useState(false)
  const [file, setFile] = useState(null)
  const [fileURL, setFileURL] = useState('')
  const [isFileLoader, setIsFileLoader] = useState(false);
  const [fileList, setFileList] = useState([]);
  const [bulkUploadResult, setBulkUploadResult] = useState({});
  const [resultText, setResultText] = useState('')
  const [resultDescription, setResultDescription] = useState('')


  const [upload, setUpload] = useState(false)
  const [disable, setDisable] = useState(false)
  const [isScoreConfirmed, setIsScoreConfirmed] = useState(false);
  const [loading, setLoading] = useState(false);
  const [confirmDrawer, setConfirmDrawer] = useState(false);
  const [conflictDrawer, setConflictDrawer] = useState(false);
  const [isAssessmentUpload, setIsAssessmentUpload] = useState(false);
  const [conflictFilter, setConflictFilter] = useState({
    search: '',
    page: 0,
  });

  const [otherError, setOtherError] = useState('')
  const [conflictData, setConflictData] = useState([])
  const [debouncedSearch, setDebouncedSearch] = useState(
    () => conflictFilter.search
  )
  const [filteredNextRounds, setFilteredNextRounds] = useState([])
  const [finalUpload, setFinalUpload] = useState(0)
  const [isLoading, setISLoading] = useState(false)
  const handleOfferUpload = useCallback((type) => {
    setIsDrawer(false)
    setIsOfferDrawer(true)
    setOfferType(type)
  }, [])

  const handleUpload = useCallback(() => {
    setIsDrawer(false)
    setUploadResult(true)
    setUpload(false)
  }, [])
  
  const handleUploadShortlisted = useCallback(() => {
    setIsDrawer(false)
    setUploadShortlisted(true)
    setSelectedRound(filteredNextRounds[0]?.value)
  }, [filteredNextRounds])

  useEffect(() => {
    setSelectedRoleId(noNeedRole ? roleId : driveRoleList[0]?.roleId)
  }, [driveRoleList, noNeedRole, roleId])

  useEffect(() => {
    if (driveId && selectedRoleId) {
      dispatch(getRoleMetrics(driveId, selectedRoleId))
    }
  }, [driveId, selectedRoleId])
  const handleAssessmentUpload = useCallback(() => {
    setIsDrawer(false)
    setIsAssessmentUpload(true)
  }, [])

  const DrawerContent = React.memo(({stage, rolesMetrics, handleUpload, handleUploadShortlisted, handleOfferUpload,checkType,handleAssessmentUpload}) => {
    return (
      <Fragment>
        {stage !== 'offer' ? (
          <>
          {checkType !== 'CV_SCREENING' && checkType !=='ASSESMENT' && (
          <Wrapper
            onClick={
              (stage === 'all_candidates' || stage === null || rolesMetrics?.count === 0) ? null : handleUpload
            }
            pointer={
              (rolesMetrics?.count === 0 && stage !== 'all_candidates') || stage === null
            }
            opacity={
              rolesMetrics?.count === 0 || stage === 'all_candidates' || stage === null
            }
          >
            <Flex>
              <IconWrapper padding>
                <UploadIcon />
              </IconWrapper>
            </Flex>
            <Flex column center>
              <TextWrapper>Upload Result</TextWrapper>
              <SubTextWrapper>
                Use this option to upload the complete list of candidate scores 
              </SubTextWrapper>
              <SubTextWrapper>from the recent round.</SubTextWrapper>
            </Flex>
          </Wrapper>
        )}

          {checkType === 'ASSESMENT' && (
          <Wrapper
          onClick={() => {
            if (rolesMetrics?.count > 0) {
              handleAssessmentUpload();
            }
          }}
          pointer={(rolesMetrics?.count > 0)?false:true}
          opacity={(rolesMetrics?.count > 0)? false:true}
        >
            <Flex>
              <IconWrapper padding>
                <UploadIcon />
              </IconWrapper>
            </Flex>
            <Flex column center>
              <TextWrapper>Upload Result</TextWrapper>
              <SubTextWrapper>
                Use this option to upload the complete list of candidate scores
              </SubTextWrapper>
              <SubTextWrapper>from the recent round.</SubTextWrapper>
            </Flex>
          </Wrapper>
          )}
  
            <Wrapper
              onClick={handleUploadShortlisted}
              pointer={rolesMetrics?.count === 0}
              opacity={rolesMetrics?.count === 0}
            >
              <Flex>
                <IconWrapper padding>
                  <UploadIcon />
                </IconWrapper>
              </Flex>
              <Flex column center>
                <TextWrapper>Upload Shortlisted Candidates</TextWrapper>
                <SubTextWrapper>
                  Use this option to upload shortlisted candidates.
                </SubTextWrapper>
                {checkType !== 'ASSESMENT' && (
                  <SubTextWrapper>Include score if available.</SubTextWrapper>
                )}
              </Flex>
            </Wrapper>
          </>
        ) : (
          <>
            <Wrapper
              onClick={stage === 'offer' ? () => handleOfferUpload('ISSUED') : null}
              pointer={rolesMetrics?.count === 0 && stage !== 'offer'}
              opacity={rolesMetrics?.count === 0 && stage !== 'offer'}
            >
              <Flex>
                <IconWrapper padding>
                  <UploadIcon />
                </IconWrapper>
              </Flex>
              <Flex column center>
                <TextWrapper>Upload Offer Issued Student</TextWrapper>
                <SubTextWrapper>Upload result in Excel sheet</SubTextWrapper>
              </Flex>
            </Wrapper>
  
            <Wrapper
              onClick={stage === 'offer' ? () => handleOfferUpload('ACCEPTED') : null}
              pointer={rolesMetrics?.count === 0 && stage !== 'offer'}
              opacity={rolesMetrics?.count === 0 && stage !== 'offer'}
            >
              <Flex>
                <IconWrapper padding>
                  <UploadIcon />
                </IconWrapper>
              </Flex>
              <Flex column center>
                <TextWrapper>Upload Offer Accepted Student</TextWrapper>
                <SubTextWrapper>Upload result in Excel sheet</SubTextWrapper>
              </Flex>
            </Wrapper>
          </>
        )}
      </Fragment>
    );
  });
  
const downloadSampleTemplate = async () => {
  try {
    let tempUrl = '';
    const paramUrl = process.env.REACT_APP_SAMPLE_PARAMETER_TEMPLATE_URL;
    const normalUrl = process.env.REACT_APP_DOWNLOAD_SAMPLE_TEMPLATE_URL;
    if (isScoreConfirmed === true && checkType === 'ASSESMENT') {
      tempUrl = paramUrl;
    } else if (isScoreConfirmed === true && stage !== 'offer') {
      tempUrl = paramUrl;
    } else if (checkType === 'ASSESMENT') {
      tempUrl = normalUrl;
    } else {
      tempUrl = normalUrl;
    }
      
      const response = await fetch(tempUrl);
    
      if (!response.ok) throw new Error('Network response was not ok');
  
      const blob = await response.blob();
      const url = window.URL.createObjectURL(blob);
  
      const a = document.createElement('a');
      a.href = url;
      a.download = isScoreConfirmed === true ? 'Sample parameter template.xlsx' : 'SampleTemplate.xlsx'; 
      document.body.appendChild(a);
      a.click();
      a.remove();
      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error('Download failed:', error);
    }
  };
  const downloadCandidateSampleTemplate = async () => {
    try {
      const payload = {
        stage: stage == null ? 'all_candidates' : stage,
        isScore: checkType === 'ASSESMENT' ? true : isScoreConfirmed,
        status: checkType === 'ASSESMENT' ? 'SCHEDULED,TO_BE_SCHEDULED' : null,
      }
      const response = await downloadTemplate(roleId, payload)

      // Check for error responses masquerading as blobs
      const contentType = response.headers['content-type']
      if (contentType && contentType.includes('application/json')) {
        // Read the error blob and parse the JSON
        const text = await response.data.text()
        const error = JSON.parse(text)
        alert(error.message || 'Download failed')
        return
      }

      // Create and download the Excel blob
      const blob = new Blob([response.data], {
        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      })
      const url = window.URL.createObjectURL(blob)
      const link = document.createElement('a')
      link.href = url
      link.setAttribute('download', `${payload.stage} students template.xlsx`)
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
      window.URL.revokeObjectURL(url)
    } catch (error) {
      console.error('Download failed:', error)
      alert('Download failed. Please try again later.')
    }
  }
      const handleConfirm = async () => {
        setIsModalOpen(false)
        let fileUploadResponse;
        let fileUrl = '';
        
        if (fileList?.length > 0) {
          setFile(fileList[0])
          setLoading(true)
          
          try {
            fileUploadResponse = await dispatch(
              uploadFile(fileList[0]?.originFileObj, fileList[0]?.name)
            )
            if (fileUploadResponse) {
              fileUrl = fileUploadResponse
              setFileURL(fileUploadResponse)
            }
          } catch (error) {
            console.error('File upload failed:', error)
            setLoading(false)
            setErrorMessage('File upload failed. Please try again.')
            return
          }
        }
        let payLoad = {
          interviewRound: stage,
          fileUrl: fileUrl,
          nextRound: selectedRound,
          isParameterScore: isScoreConfirmed,
          roundId: stage === 'all_candidates' || stage === null || stage === 'offer' ? null : allRounds.find(item => item.roundName === stage)?.roundId,
          nextRoundId: stage === 'offer' ? null : allRounds?.find(item => item.roundName === selectedRound)?.roundId,
        }
      

        try {
          let response = await uploadShorlistResult(roleId, payLoad)
          if (response?.status === 200) {
            // Set the bulk upload result with proper data structure
            setBulkUploadResult(response?.data || {})
            setIsFileLoader(false)
            setOtherError('')
            setLoading(false)
            setIsModalOpen(false)
            dispatch(getRoleMetrics(driveId, selectedRoleId))
            await getCandidateList()
            setFileList([])
          } else {
            // Handle error case
            setBulkUploadResult({})
            setIsFileLoader(false)
            setLoading(false)
            setTimeout(() => {
              setErrorMessage(response?.response?.data?.message)
            }, 1000)
          }
        } catch (error) {
          console.error('Upload error:', error)
          setBulkUploadResult({})
          setIsFileLoader(false)
          setLoading(false)
          setTimeout(() => {
            setErrorMessage(error?.response?.data?.message)
          }, 1000)
        }
      }

      const handleOfferConfirm = async (offerType) => {
        let payLoad = {
          interviewRound: 'offer',
          fileUrl: fileURL,
          offerType: offerType,
          nextRound: 'offer',
          isParameterScore: false,
        }

        try {
          let response = await uploadShorlistResult(roleId, payLoad)
          if (response?.status >= 200 && response?.status <= 300) {
            setResultText('Bulk Upload Updated Successfully')
            setResultDescription(null)
            setConfirmDrawer(true)
            setIsModalOpen(false)
            setIsDrawer(false)
            setUploadShortlisted(false)
            setIsOfferDrawer(false)
            setOfferType(null)
            dispatch(getRoleMetrics(driveId, selectedRoleId))
            await getCandidateList()
            setFileURL('')
            setFile(null)
          } else {
            setTimeout(() => {
              setErrorMessage(response?.data?.message || 'Upload failed. Please try again.')
            }, 1000)
          }
        } catch (error) {
          setTimeout(() => {
            setErrorMessage(error?.response?.data?.message)
          }, 1000)
        }
      }

      const handlePageChange = pageNum => {
        setConflictFilter({ ...conflictFilter, page: pageNum - 1 })
      }
      const handleSearch = (e) => {
        const value = e?.target?.value || e
        setConflictFilter({ ...conflictFilter, search: value })
      }

      React.useEffect(() => {
        const timeout = setTimeout(() => {
          setDebouncedSearch(conflictFilter.search)
          setConflictFilter({ ...conflictFilter, page: 0 })
        }, 1000)
        return () => {
          clearTimeout(timeout)
        }
      }, [conflictFilter.search])
      const handleShortListBtn = async (roleId,conflictId) => {
        setISLoading(true)
        const payload = {}
        const response = await updateResolveConflictCandidates(roleId, conflictId, payload)
        if (response?.status  === 200) {
          setConflictDrawer(false)
          dispatch(getRoleMetrics(driveId, roleId))
          setConflictFilter({ ...conflictFilter, page: 0 })
          setIsDrawer(false)
          await getCandidateList()
          setISLoading(false)
        }else{
          setISLoading(false)
          setErrorMessage(response?.data?.message)
        }
      }
      useEffect(() => {
      const stageIndex = nextRoundData?.findIndex(
        r => r?.value?.toLowerCase() === stage?.toLowerCase()
      );
      
      setFilteredNextRounds (stageIndex >= 0
        ? nextRoundData.slice(stageIndex + 1)
        : nextRoundData)
    },[nextRoundData,stage])

      const ConflictColumn = [
        {
          width: 140,
          title: 'Uploaded Data',
          dataIndex: 'Uploaded Data',
          key: 'Uploaded Data',
          className: 'uploaded-data',
          render: (text, record) => {
            const { email, lastName, firstName, phoneNumber } =
              record.uploadedCandidateData
            const disable = record.candidateDetails.every(
              item =>
                item.primaryEmail?.toLowerCase()?.trim() ===
                email?.toLowerCase()?.trim()
            )
            const nameDisable = record.candidateDetails.every(
              item =>
                item?.student?.firstName?.toLowerCase()?.trim() ===
                firstName?.toLowerCase()?.trim()
            )
            const lastDisable = record.candidateDetails.every(
              item =>
                item?.student?.lastName?.toLowerCase()?.trim() ===
                lastName?.toLowerCase()?.trim()
            )
            const phoneDisable = record?.candidateDetails?.every(
              item => item?.contactNumber?.trim() === phoneNumber?.trim()
            )
            return (
              <Tooltip
                title={
                  <div>
                    {firstName}
                    {lastName}
                    <br />
                    {phoneNumber}
                    <br />
                    {email}
                  </div>
                }
              >
                <TextEllipse disable={nameDisable}>
                  {firstName}{' '}
                  <span
                    style={{ color: lastDisable ? '#000' : 'rgb(227, 94, 80)' }}
                  >
                    {lastName}
                  </span>
                </TextEllipse>
    
                <ConflictName disable={phoneDisable}>{phoneNumber}</ConflictName>
                <ConflictName disable={disable}>{email}</ConflictName>
              </Tooltip>
            )
          },
          onCell: (record, index) => {
            const rowSpan =
              record.candidateDetails.length == 0
                ? 1
                : record.candidateDetailIndex === 0
                ? record.candidateDetails.length
                : 0
            return { rowSpan }
          },
        },
        {
          width: 140,
          title: 'Name',
          dataIndex: 'Name',
          key: 'Name',
          render: (text, record) => {
            const enableMinus = record.candidateDetail === null
         
            const { firstName, lastName } = record?.candidateDetail || {}
    
            const disable =
              record?.uploadedCandidateData?.firstName?.toLowerCase()?.trim() ===
              firstName?.toLowerCase()?.trim()
    
            const lastDisable =
              record?.uploadedCandidateData?.lastName?.toLowerCase()?.trim() ===
              lastName?.toLowerCase()?.trim()
    
            //display
            
    const firstStudentName = firstName?.trim() ? toCamelCase(firstName) : '';
    const lastStudentName = lastName?.trim() ? toCamelCase(lastName) : '';
    
            return (
              <>
                {enableMinus ? (
                  <Minus>-</Minus>
                ) : (
                  <Tooltip
                    title={
                      <div>
                        {firstStudentName} {lastStudentName}
                      </div>
                    }
                  >
                    <ConflictName disable={disable} caps={true}>
                      {firstStudentName}{' '}
                      <span
                        style={{ color: lastDisable ? '#000' : 'rgb(227, 94, 80)' }}
                      >
                        {lastStudentName}
                      </span>
                    </ConflictName>
                  </Tooltip>
                )}
              </>
            )
          },
        },
        {
          width: 140,
          title: 'Contact details',
          dataIndex: 'Contact details',
          key: 'Contact details',
          render: (text, record) => {
            const enableMinus = record.candidateDetail === null
    
            const { primaryEmail, secondaryEmail, contactNumber } =
              record?.candidateDetail || {}
            const EmailDisable =
              primaryEmail?.toLowerCase()?.trim() ===
              record?.uploadedCandidateData?.email?.toLowerCase()?.trim()
            const secondaryEmailDisable =
              secondaryEmail?.toLowerCase()?.trim() ===
              record?.uploadedCandidateData?.email?.toLowerCase()?.trim()
            const phoneDisable =
            contactNumber?.trim() ===
              record?.uploadedCandidateData?.phoneNumber?.trim()
    
            //display
            let pEmail = primaryEmail ? primaryEmail?.toLowerCase() : primaryEmail
            let sEmail = secondaryEmail
              ? secondaryEmail?.toLowerCase()
              : secondaryEmail
            return (
              <>
                {enableMinus ? (
                  <Minus>-</Minus>
                ) : (
                  <Tooltip
                    title={
                      <div>
                        {pEmail}
                        <br />
                        {sEmail}
                        <br />
                        {contactNumber}
                      </div>
                    }
                  >
                    <ConflictName disable={EmailDisable}>{pEmail}</ConflictName>
                    <ConflictName disable={secondaryEmailDisable}>
                      {sEmail}
                    </ConflictName>
                    <ConflictName disable={phoneDisable}>
                      {contactNumber}
                    </ConflictName>
                  </Tooltip>
                )}
              </>
            )
          },
        },
        {
          width: 140,
          title: 'Degree & Department',
          dataIndex: 'Degree & Department',
          key: 'Degree & Department',
          render: (text, record) => {
            const enableMinus = record.candidateDetail === null
    
            const degree = record?.candidateDetail?.degree ?? ''
            const department = record?.candidateDetail?.department ?? ''
            const Degree = degree?.trim() ? toCamelCase(degree) : ''
            const Department = department?.trim() ? toCamelCase(department) : ''
            return (
              <div style={{ textAlign: 'left' }}>
                {enableMinus ? (
                  <Minus>-</Minus>
                ) : (
                  <Tooltip
                    title={
                      <div>
                        {Degree}
                        <br />
                        {Department}
                      </div>
                    }
                  >
                    <ConflictName disable={true} caps={true}>
                      {Degree}
                    </ConflictName>
                    <ConflictName disable={true} caps={true}>
                      {Department}
                    </ConflictName>
                  </Tooltip>
                )}
              </div>
            )
          },
        },
        {
          width: 140,
          title: 'Move to',
          dataIndex: 'Move to',
          key: 'Move to',
          className: 'conflict-staus-action',
          render: (text, record) => {
            const disable = record.candidateDetail === null;
            const isOfferStage = record.stage === 'offer'; // check lowercase if your data uses it
        
            return (
              <>
                {!isOfferStage ? (
                  <>
                    <ShortList
                      disable={disable}
                      onClick={() =>
                        handleShortListBtn(
                          record?.jobId,
                          record?.id
                        )
                      }
                    >
                      <div style={{ display: 'flex', alignItems: 'center' }}>
                                <ArrowForward 
                                  color="#3249D7" 
                                  width="14" 
                                  height="14" 
                                  style={{ marginRight: '5px' }} 
                                />
                                Round {record?.roundIndex}
                              </div>
                    </ShortList>
                    <div
                      style={{
                        fontSize: '12px',
                        color: '#000',
                        fontWeight: '500',
                        marginTop: '5px',
                        marginLeft: '20px',
                      }}
                    >
                      {record?.nextRound}
                    </div>
                  </>
                ) : (
                  <ShortList
                  disable={disable}
                  onClick={() =>
                    handleShortListBtn(
                      record?.jobId,
                      record?.id
                    )
                  }
                >
                  <div style={{ display: 'flex', alignItems: 'center' }}>
                    <ArrowForward color="#3249D7" width="14" height="14" style={{ marginRight: '5px' }} />
                    {record?.nextRound}
                  </div>
                </ShortList>
                )}
              </>
            );
          },
        }
        
      ]

      const handleClose = () => {
        setConflictDrawer(false)
       if(stage !== 'offer'){
        setUploadShortlisted(true);
       }else{
        setIsOfferDrawer(true);
       }
        setConflictFilter({
          search: '',
          page: 0,
        })
      }
    
      const ConflictContent = () => {
        return (
          <ResolveConflict
            conflictData={conflictData}
            conflictFilter={conflictFilter}
            handlePageChange={handlePageChange}
            handleSearch={(e)=>handleSearch(e)}
            // handleShortListBtn={handleShortListBtn}
            isLoading={isLoading}
            columns={ConflictColumn}
          />
        )
      }
      const getConflict = async () => {
        try {
          const getConflictData = await getConflictCandidates(roleId, {
            pageNo: 0,
            pageLimit: 10,
            roundId: roundId,
            search: debouncedSearch,
            stage:stage
          })
          setConflictData(getConflictData)
        } catch (err) {
          setErrorMessage(err)
        }
      }
      const handleResolveConflict = async () => {
        setConflictDrawer(true)
        setConflictFilter({
          search: '',
          page: 0,
        })
        try {
          setISLoading(true)
    
          const getConflictData = await getConflictCandidates(
            roleId,
            {
              pageNo: 0,
              pageLimit: 10,
              roundId: roundId,
              stage:stage
            }
          )
          setISLoading(false)
          setConflictData(getConflictData)
        } catch (err) {
          setErrorMessage(err)
        }
      }
      
      useEffect(() => {
        getConflict()
      },[debouncedSearch,conflictFilter.page])
      
    const handleAssessmentConfirm = async (nextRoundName) => {
      let payLoad = {
        interviewRound: stage,
        fileUrl: fileURL,
        nextRound: nextRoundName,
        isParameterScore: true,
        roundId: allRounds.find(item => item.roundName === stage)?.roundId,
        nextRoundId: allRounds?.find(item => item.roundName === nextRoundName)?.roundId,
      }
    

      try {
        let response = await uploadShorlistResult(roleId, payLoad)
  
        if (response?.status === 200) {
          setResultText('Result Updated Successfully')
          setResultDescription('File has been successfully updated with active candidates.')
          setConfirmDrawer(true)
          setFileList([])
          setFile(null)
          setIsFileLoader(false)
          setLoading(false)
          dispatch(getRoleMetrics(driveId, selectedRoleId))
          await getCandidateList()
        } else {
          // Handle error case
          setIsFileLoader(false)
          setLoading(false)
          setTimeout(() => {
            setErrorMessage(response?.response?.data?.message)
          }, 1000)
        }
      } catch (error) {
        console.error('Upload error:', error)
      }
    }

      const handleClearUpload = () => {
        setIsDrawer(false)
        setUploadShortlisted(false)
        setFileURL('')
        setFile(null)
        setFileList([])
        setBulkUploadResult({})
        setOtherError('')
        setIsFileLoader(false)
        setLoading(false)
      }
      const handleConfirmClose = () => {
        setConfirmDrawer(false)
        setIsDrawer(false)
        setIsAssessmentUpload(false)
        setUploadShortlisted(false)
      }
      const handleStatus = () => {
        setIsAllSelected(false)
        setSelectedIds([])
        setWholeSelect(false)
        setIsDrawer(true)
      }
  return (
    <>
      <Button.Secondary
        text={triggerLabel || 'Upload Result'}
        height={'38px'}
        onClick={() => {
          handleStatus()

        }}
        disabled={disable}
      />
      <Drawer
        title={stage === 'offer' ? 'Bulk Upload' : 'Download / Upload'}
        placement="right"
        visible={isDrawer}
        content={<DrawerContent
          stage={stage}
          rolesMetrics={rolesMetrics}
          handleUpload={handleUpload}
          handleUploadShortlisted={handleUploadShortlisted}
          handleOfferUpload={handleOfferUpload}
          checkType={checkType}
          handleAssessmentUpload={handleAssessmentUpload}
           />} 
        onClose={() => {
          setIsDrawer(false)
        }}
        closable
      />
      {/* <DownLoadCandidate
        downloadCand={downloadCand}
        setDownloadcand={setDownloadCand}
        driveRoleList={driveRoleList}
        selectedRoleId={selectedRoleId}
        setSelectedRoleId={setSelectedRoleId}
        roundList={roundList}
        downloadCandidate={downloadCandidate}
        driveId={driveId}
        setIsDrawer={setIsDrawer}
        noNeedRole={noNeedRole}
        roleId={roleId}
        stage={stage}
      /> */}
  
  
      <UploadResult
        uploadResult={uploadResult}
        setUploadResult={setUploadResult}
        driveRoleList={driveRoleList}
        selectedRoleId={selectedRoleId}
        setSelectedRoleId={setSelectedRoleId}
        roundList={roundList}
        noNeedRole={noNeedRole}
        downloadCandidateList={downloadCandidateList}
        driveId={driveId}
        roleId={roleId}
        uploadResultAPI={uploadResultAPI}
        setIsDrawer={setIsDrawer}
        getCandidateList={getCandidateList}
        getGDList={getGDList}
        getRoleMetrics={getRoleMetrics}
        upload={upload}
        setUpload={setUpload}
        externalAssessment={true}
        fileUpload={fileUpload}
        stage={stage}
        checkType={checkType}
        assessment={assessment}
        rolesMetrics={rolesMetrics}
        setSearchParams={setSearchParams}
        searchParams={searchParams}
        loading={loading}
      />
      <UploadShortlistedDrawer
        uploadShortlisted={uploadShortlisted}
        setUploadShortlisted={setUploadShortlisted}
        setIsDrawer={setIsDrawer}
        stage={stage}
        roleId={roleId}
        downloadCandidateSampleTemplate={downloadSampleTemplate}
        isScoreConfirmed={isScoreConfirmed}
        setIsScoreConfirmed={setIsScoreConfirmed}
        rounds={rounds}
        nextRoundData={filteredNextRounds}
        selectedRound={selectedRound}
        setSelectedRound={setSelectedRound}
        isDrawer={isDrawer}
        getCandidateList={getCandidateList}
        isModalOpen={isModalOpen}
        setIsModalOpen={setIsModalOpen}
        handleConfirm={handleConfirm}
        file={file}
        setFile={setFile}
        fileURL={fileURL}
        setFileURL={setFileURL}
        loading={loading}
        isFileLoader={isFileLoader}
        setIsFileLoader={setIsFileLoader}
        fileList={fileList}
        setFileList={setFileList}
        bulkUploadResult={bulkUploadResult}
        setErrorMessage={setErrorMessage}
        otherError={otherError}
        setOtherError={setOtherError}
        handleClearUpload={handleClearUpload}
        setFinalUpload={setFinalUpload}
        finalUpload={finalUpload}
        handleResolveConflict={handleResolveConflict}
        checkType={checkType}
      />
        <UploadAssessmentDrawer
        uploadShortlisted={isAssessmentUpload}
        setUploadShortlisted={setIsAssessmentUpload}
        setIsDrawer={setIsDrawer}
        downloadCandidateSampleTemplate={downloadCandidateSampleTemplate}
        isDrawer={isDrawer}
        handleAssessmentConfirm={handleAssessmentConfirm}
        file={file}
        setFile={setFile}
        fileURL={fileURL}
        setFileURL={setFileURL}
        loading={loading}
        setIsFileLoader={setIsFileLoader}
        setErrorMessage={setErrorMessage}
        nextRoundData={filteredNextRounds}
      />
     
      <UploadOfferDrawer
       isOfferDrawer={isOfferDrawer}
       setIsOfferDrawer={setIsOfferDrawer}
        downloadCandidateSampleTemplate={downloadSampleTemplate}
        setIsDrawer={setIsDrawer}
        handleOfferConfirm={handleOfferConfirm}
        file={file}
        setFile={setFile}
        fileURL={fileURL}
        setFileURL={setFileURL}
        offerType={offerType}
          loading={loading}
          isFileLoader={isFileLoader}
          setIsFileLoader={setIsFileLoader}
          fileList={fileList}
          setFileList={setFileList}
          bulkUploadResult={bulkUploadResult}
          setErrorMessage={setErrorMessage}
          otherError={otherError}
          setOtherError={setOtherError}
          setFinalUpload={setFinalUpload}
          finalUpload={finalUpload}
          handleClearUpload={handleClearUpload}
      />
        <Drawer
        width="70%"
        title={'Conflicts'}
        placement="right"
        closable={true}
        visible={conflictDrawer}
        content={ConflictContent()}
        footer={false}
        zIndex={1005}
        onClose={() => handleClose()}
      />
      <ConfirmDrawer
        confirmDrawer={confirmDrawer}
        setConfirmDrawer={setConfirmDrawer}
        file={file}
        rolesMetrics={rolesMetrics}
        setSearchParams={setSearchParams}
        searchParams={searchParams}
        handleClose={handleConfirmClose}
        resultText={resultText}
        resultDescription={resultDescription}
      />
      
    </>
  )
}

export default DownlaodUpload
